<template>
  <div>
    <h3>道具退款</h3>
    <el-form :inline="true" size="mini">
      <el-form-item label="用户ID">
        <el-input v-model="queryParams.userId" placeholder="请输入用户ID"></el-input>
      </el-form-item>
      <el-form-item label="订单ID">
        <el-input v-model="queryParams.orderId" placeholder="请输入道具ID"></el-input>
      </el-form-item>
      <el-form-item label="退款来源">
        <el-select v-model="queryParams.refundSource" placeholder="请选择退款来源" clearable>
          <el-option
            v-for="(label, value) in refundSourceMap"
            :key="value"
            :label="label"
            :value="Number(value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="道具状态">
        <el-select v-model="queryParams.status" placeholder="请选择道具状态" clearable>
          <el-option
            v-for="(label, value) in statusMap"
            :key="value"
            :label="label"
            :value="Number(value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="退款原因">
        <el-input v-model="queryParams.refundReason" placeholder="请输入退款原因"></el-input>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="queryParams.createTimeStart"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="queryParams.createTimeEnd"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="更新时间">
        <el-date-picker
          v-model="queryParams.updateTimeStart"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="queryParams.updateTimeEnd"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="search">查询</el-button>
        <el-button type="primary" size="mini" @click="rest">重置</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="list" size="mini">
      <el-table-column prop="refundId" label="退款ID" width="180"></el-table-column>
      <el-table-column prop="userId" label="用户ID" width="120"></el-table-column>
      <el-table-column prop="orderId" label="订单ID" width="180"></el-table-column>
      <el-table-column prop="title" label="道具订单标题" width="220"></el-table-column>
      <el-table-column prop="amount" label="订单金额" width="120"></el-table-column>
      <el-table-column prop="refundAmount" label="应退金额" width="120"></el-table-column>
      <el-table-column prop="actualAmount" label="实退金额" width="120"></el-table-column>
      <el-table-column prop="nickname" label="用户昵称" width="120"></el-table-column>
      <el-table-column prop="role" label="用户身份" width="120">
        <template slot-scope="scope">{{ roleMap[scope.row.role] || '-' }}</template>
      </el-table-column>
      <el-table-column prop="refundSource" label="退款来源" width="100">
        <template slot-scope="scope">{{ refundSourceMap[scope.row.refundSource] || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdBy" label="退款创建人" width="120"></el-table-column>
      <el-table-column prop="status" label="退款状态" width="100">
        <template slot-scope="scope">{{ statusMap[scope.row.status] || '-' }}</template>
      </el-table-column>
      <el-table-column prop="refundReason" label="退款原因" min-width="180"></el-table-column>
      <el-table-column prop="closeReason" label="关闭原因" min-width="180"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="160"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <template v-if="scope.row.status === 1">
            <el-button type="primary" size="mini" @click="handleRefund(scope.row)">
              完成退款
            </el-button>
            <el-button type="danger" size="mini" @click="handleRefuseRefund(scope.row)">
              关闭退款
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="queryParams.pageNum"
      :page-size="queryParams.limit"
      :total="total"
      @current-change="currentChange"
    >
    </el-pagination>
    <el-dialog title="同意退款" :visible.sync="refundDialogVisible" :close-on-click-modal="false" :before-close="closeRefund" width="600px">
      <div class="refund-confirm">
        <el-form label-width="100px" size="mini">
          <el-form-item label="退款单ID">
            <el-input :value="refundData.refundId" disabled></el-input>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input :value="refundData.userId" disabled></el-input>
          </el-form-item>
          <el-form-item label="道具订单ID">
            <el-input :value="refundData.orderId" disabled></el-input>
          </el-form-item>
          <el-form-item label="退款状态">
            <el-input :value="statusMap[refundData.status] || '-'" disabled></el-input>
          </el-form-item>
          <el-form-item label="应退金额">
            <el-input :value="'￥' + refundData.refundAmount" disabled></el-input>
          </el-form-item>
        </el-form>
        <el-form :model="refundForm" :rules="refundRules" ref="refundForm" label-width="100px" size="mini">
          <el-form-item label="实退金额" prop="amount">
            <el-input
              v-model.trim="refundForm.amount"
              placeholder="请输入实际退款金额"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRefund">取消</el-button>
        <el-button type="primary" @click="submitRefund">确认退款</el-button>
      </div>
    </el-dialog>
    <el-dialog title="关闭退款" :visible.sync="refuseDialogVisible" :close-on-click-modal="false" :before-close="closeRefuseRefund" width="600px">
      <div class="refund-confirm">
        <el-form label-width="100px" size="mini">
          <el-form-item label="退款单ID">
            <el-input :value="refuseData.refundId" disabled></el-input>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input :value="refuseData.userId" disabled></el-input>
          </el-form-item>
          <el-form-item label="道具订单ID">
            <el-input :value="refuseData.orderId" disabled></el-input>
          </el-form-item>
          <el-form-item label="退款状态">
            <el-input :value="statusMap[refuseData.status] || '-'" disabled></el-input>
          </el-form-item>
          <el-form-item label="应退金额">
            <el-input :value="'￥' + refuseData.refundAmount" disabled></el-input>
          </el-form-item>
        </el-form>
        <el-form :model="refuseForm" :rules="refuseRules" ref="refuseForm" label-width="100px" size="mini">
          <el-form-item label="关闭原因" prop="closeReason">
            <div class="close-reason-title">请选择关闭原因（必选 · 此原因将展示给用户）：</div>
            <el-radio-group class="close-reason-group" v-model="refuseForm.closeReason">
              <el-radio
                v-for="reason in closeReasonOptions"
                :key="reason"
                :label="reason"
              >{{ reason }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="refuseForm.closeReason === otherCloseReason" label="其他原因" prop="customReason">
            <el-input
              v-model.trim="refuseForm.customReason"
              type="textarea"
              :rows="3"
              placeholder="请填写用户能理解的关闭原因"
            ></el-input>
            <div class="close-reason-tip">
              自定义文本将直接展示给用户，请使用用户能理解的措辞，不要写“飞书”、“审批”、“驳回”等内部术语。
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRefuseRefund">取消</el-button>
        <el-button type="primary" @click="submitRefuseRefund">确认关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../api';

const { prop } = api;

export default {
  name: 'propRefund',
  data() {
    return {
      loading: false,
      list: [],
      queryParams: {
        pageNum: 1,
        limit: 30,
        refundSource: '',
        status: '',
        userId: '',
        orderId: '',
        refundReason: '',
        createTimeStart: '',
        createTimeEnd: '',
        updateTimeStart: '',
        updateTimeEnd: '',
      },
      total: 0,
      refundDialogVisible: false,
      refundData: {},
      refundForm: {
        refundId: '',
        amount: '',
      },
      refuseDialogVisible: false,
      refuseData: {},
      otherCloseReason: '其他（请说明）',
      refuseForm: {
        refundId: '',
        closeReason: '',
        customReason: '',
      },
      refundRules: {
        amount: [
          { required: true, message: '请输入实际退款金额', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const amount = Number(value);
              const refundableAmount = Number(this.refundData.refundAmount);
              if (value === '' || Number.isNaN(amount)) {
                callback(new Error('实际退款金额必须为数字'));
              } else if (amount <= 0) {
                callback(new Error('实际退款金额必须大于 0'));
              } else if (amount > refundableAmount) {
                callback(new Error('实际退款金额不能大于应退金额'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      refuseRules: {
        closeReason: [
          { required: true, message: '请选择关闭原因', trigger: 'change' },
        ],
        customReason: [
          {
            validator: (rule, value, callback) => {
              if (this.refuseForm.closeReason === this.otherCloseReason && !value) {
                callback(new Error('请填写自定义关闭原因'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      closeReasonOptions: [
        '您主动撤回了退款申请',
        '经核实，订单不符合退款条件',
        '退款信息有误，请联系客服重新申请',
        '其他（请说明）',
      ],
      refundSourceMap: {
        1: '用户申请',
        2: '运营操作',
      },
      roleMap: {
        1: '甲方',
        2: '乙方',
      },
      statusMap: {
        1: '退款中',
        2: '已退款',
        3: '已关闭',
      },
    };
  },
  methods: {
    search() {
      this.queryParams.pageNum = 1;
      this.fetch();
    },
    rest() {
      this.queryParams = {
        pageNum: 1,
        limit: 30,
        refundSource: '',
        status: '',
        userId: '',
        orderId: '',
        refundReason: '',
        createTimeStart: '',
        createTimeEnd: '',
        updateTimeStart: '',
        updateTimeEnd: '',
      };
      this.fetch();
    },
    async fetch() {
      this.loading = true;
      try {
        const res = await prop.refundList(this.queryParams);
        this.list = res.data.data || [];
        this.total = res.data.pageinfo ? res.data.pageinfo.totalCount : this.list.length;
      } finally {
        this.loading = false;
      }
    },
    currentChange(pageNum) {
      this.queryParams.pageNum = pageNum;
      this.fetch();
    },
    async exportExcel() {
      this.loading = true;
      try {
        const params = Object.assign({}, this.queryParams);
        delete params.pageNum;
        delete params.limit;
        const resp = await prop.refundExport(params);
        const objectUrl = URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.download = decodeURIComponent('道具退款列表.xlsx');
        link.href = objectUrl;
        link.click();
        URL.revokeObjectURL(objectUrl);
      } finally {
        this.loading = false;
      }
    },
    handleRefund(row) {
      this.refundData = row;
      this.refundForm.refundId = row.refundId;
      this.refundForm.amount = row.refundAmount;
      this.refundDialogVisible = true;
    },
    handleRefuseRefund(row) {
      this.refuseData = row;
      this.refuseForm.refundId = row.refundId;
      this.refuseDialogVisible = true;
    },
    submitRefund() {
      this.$refs.refundForm.validate(async (valid) => {
        if (!valid) return;
        await prop.agreeRefund(this.refundForm);
        this.$message.success('退款成功');
        this.closeRefund();
        this.fetch();
      });
    },
    submitRefuseRefund() {
      this.$refs.refuseForm.validate(async (valid) => {
        if (!valid) return;
        const closeReason = this.refuseForm.closeReason === this.otherCloseReason
          ? this.refuseForm.customReason
          : this.refuseForm.closeReason;
        await prop.refuseRefund({
          refundId: this.refuseForm.refundId,
          closeReason,
        });
        this.$message.success('关闭成功');
        this.closeRefuseRefund();
        this.fetch();
      });
    },
    closeRefund() {
      this.refundDialogVisible = false;
      this.refundData = {};
      this.refundForm = {
        refundId: '',
        amount: '',
      };
      this.$nextTick(() => {
        this.$refs.refundForm && this.$refs.refundForm.clearValidate();
      });
    },
    closeRefuseRefund() {
      this.refuseDialogVisible = false;
      this.refuseData = {};
      this.refuseForm = {
        refundId: '',
        closeReason: '',
        customReason: '',
      };
      this.$nextTick(() => {
        this.$refs.refuseForm && this.$refs.refuseForm.clearValidate();
      });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style>
.close-reason-title {
  line-height: 24px;
  margin-bottom: 6px;
}

.close-reason-group .el-radio {
  display: block;
  line-height: 28px;
  margin-left: 0;
}

.close-reason-tip {
  color: #e6a23c;
  line-height: 20px;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/prop/refund.vue